import { ReactNode, createContext, useContext, useRef } from 'react';

type CloseCallback = () => void;

export type InfoPopoverGroupHandle = {
  notifyOpen: (id: string) => void;
  subscribe: (id: string, close: CloseCallback) => () => void;
};

export const InfoPopoverGroupContext = createContext<InfoPopoverGroupHandle | null>(null);

export function useInfoPopoverGroup(): InfoPopoverGroupHandle {
  const closersRef = useRef<Map<string, CloseCallback>>(new Map());

  const handleRef = useRef<InfoPopoverGroupHandle>({
    notifyOpen(id: string) {
      closersRef.current.forEach((close, closerId) => {
        if (closerId !== id) {
          close();
        }
      });
    },
    subscribe(id: string, close: CloseCallback) {
      closersRef.current.set(id, close);
      return () => {
        closersRef.current.delete(id);
      };
    },
  });

  return handleRef.current;
}

export type InfoPopoverGroupProps = {
  children: ReactNode;
};

export function InfoPopoverGroup({ children }: InfoPopoverGroupProps) {
  const group = useInfoPopoverGroup();

  return <InfoPopoverGroupContext.Provider value={group}>{children}</InfoPopoverGroupContext.Provider>;
}

export function useInfoPopoverGroupContext(): InfoPopoverGroupHandle | null {
  return useContext(InfoPopoverGroupContext);
}
